import React from 'react'
import type {
  ActivityInformation,
  Edge,
  GroupItem,
} from '../../../../../typings'
import SmallerScreenGroupDetail from '../SmallerScreenGroupDetail'
import OtherScreensGroupDetail from '../OtherScreensGroupDetail'
import HeaderGroupDetail from '../components/HeaderGroupDetail'
import Strip from '../components/Strip'
import Activity from '../components/Activity'
import FlatProgress from '../components/FlatProgress'
import { getTransferURL } from '../../../utils/links/transferLinks'

interface GroupDetailProps {
  isSmallerScreen: boolean
  isPayPalUser: boolean
  isAdmin: boolean
  isEditEnabled: boolean
  groupId: string
  groupItem: GroupItem
  activities: Edge<ActivityInformation>[]
  totalCount: number
  reportLink: string
  handleContributeAsUser: () => void
  handleContributeAsGuest: () => void
  handleClickOnEdit: () => void
  handleClickOnReport: () => void
  formattedCreatorInfo: any
}

const GroupDetail = (props: GroupDetailProps) => {
  const strip = (
    <Strip
      backgroundImage={props.groupItem.backgroundImageUrl}
      displayEditButton={props.isEditEnabled}
      groupId={props.groupId}
    />
  )

  const headerGroupDetail = (
    <HeaderGroupDetail
      handleClickOnEdit={props.handleClickOnEdit}
      isSmallerScreen={props.isSmallerScreen}
      groupDescription={props.groupItem.description}
      groupName={props.groupItem.name}
      formattedCreatorInfo={props.formattedCreatorInfo}
      isEditEnabled={props.isEditEnabled}
      status={props.groupItem.status}
    />
  )

  const progressBar = (
    <FlatProgress
      isPayPalUser={props.isPayPalUser}
      currentAmount={props.groupItem.currentAmount}
      targetAmount={props.groupItem.targetAmount}
      collectedAmount={props.groupItem.collectedAmount}
      closingDate={props.groupItem.formattedTargetDate}
      isSmallerScreen={props.isSmallerScreen}
      isAdmin={props.isAdmin}
      transferUrl={getTransferURL(props.groupId)}
      handleContributeAsUser={props.handleContributeAsUser}
      handleContributeAsGuest={props.handleContributeAsGuest}
      formattedCurrentAmount={props.groupItem.formattedCurrentAmount}
      formattedTargetAmount={props.groupItem.formattedTargetAmount}
      formattedCollectedAmount={props.groupItem.formattedCollectedAmount}
      groupStatus={props.groupItem.status}
      groupId={props.groupId}
    />
  )

  const groupActivity = (
    <Activity
      groupId={props.groupId}
      isAdmin={props.isAdmin}
      isPayPalUser={props.isPayPalUser}
      activities={props.activities}
      isSmallerScreen={props.isSmallerScreen}
      totalCountActivities={props.totalCount ?? 0}
      groupStatus={props.groupItem.status}
    />
  )

  if (props.isSmallerScreen) {
    return (
      <SmallerScreenGroupDetail
        HeaderGroup={headerGroupDetail}
        StripComponent={strip}
        ActivityComponent={groupActivity}
        FlatProgressComponent={progressBar}
        isPayPalUser={props.isPayPalUser}
        formattedCreatorInfo={props.formattedCreatorInfo}
        closingDate={props.groupItem.formattedTargetDate}
        shareLink={props.groupItem.shareLink}
        reportLink={props.reportLink}
        handleContributeAsUser={props.handleContributeAsUser}
        handleContributeAsGuest={props.handleContributeAsGuest}
        groupStatus={props.groupItem.status}
        isAdmin={props.isAdmin}
        handleClickOnReport={props.handleClickOnReport}
        groupId={props.groupId}
      />
    )
  }

  return (
    <OtherScreensGroupDetail
      handleClickOnEdit={props.handleClickOnEdit}
      HeaderGroup={headerGroupDetail}
      StripComponent={strip}
      ActivityComponent={groupActivity}
      FlatProgressComponent={progressBar}
      shareLink={props.groupItem.shareLink}
      reportLink={props.reportLink}
      groupName={props.groupItem.name}
      groupStatus={props.groupItem.status}
      isEditEnabled={props.isEditEnabled}
      hasBackgroundImage={!!props.groupItem.backgroundImageUrl}
      isAdmin={props.isAdmin}
      handleClickOnReport={props.handleClickOnReport}
      isPayPalUser={props.isPayPalUser}
      groupId={props.groupId}
    />
  )
}

export default GroupDetail
